import React from 'react'
import { Message, MessageGeneration, ReplyMessageData } from '../types/chat';
import { useTheme } from '../../../components/core/theme-provider';
import { IamData } from '/features/iam/services/user-service';
import { Reply } from 'lucide-react';


function ReplyButton({ hasParticipantsArray, hasRemovedParticipantsArray, message, generation, setReplyMessage }: { hasParticipantsArray: IamData[], hasRemovedParticipantsArray: IamData[], message: Message, generation: MessageGeneration, setReplyMessage: (replyMessageData: ReplyMessageData) => void }) {
    const { theme } = useTheme();
    return (
        <button
            className={`p-1.5 rounded-md transition-all duration-200 ${theme === 'dark'
                ? 'text-gray-400 hover:text-gray-200 '
                : 'text-gray-500 hover:text-gray-700 '
                } focus:outline-none focus:ring-2 focus:ring-primary-500/50 opacity-0 group-hover:opacity-100 pointer-events-none group-hover:pointer-events-auto focus:opacity-100 focus:pointer-events-auto`}
            onClick={() => {
                const repliedUser = hasParticipantsArray.find(participant => participant.itemId === message.senderId)
                    || hasRemovedParticipantsArray.find(participant => participant.itemId === message.senderId);
                // console.log('Reply to message:', repliedUser, "message=>", message, "participants=>", hasParticipantsArray);
                const replyMessageData: ReplyMessageData = {
                    generation: generation,
                    repliedUser: repliedUser,
                };
                setReplyMessage(replyMessageData);
                // setOpenDropdownId(null);
            }}
            aria-label="Reply to message"
        >
            <Reply className="w-4 h-4 rotate-180" />
        </button>
    )
}

export default ReplyButton